module.exports = "<app-fichaje></app-fichaje>\r\n\r\n\r\n"